import Popup from '@shared/components/Popup/Popup';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Notification } from 'assets/icons/Notification.svg';
import ModalFooter from 'components/ModalFooter';
import testingConstants from 'utils/testingConstants';

import RemindersList from './RemindersList';
import useCreateNewRoomDataContext from '../CreateNewRoomDataProvider/useCreateNewRoomDataContext';
import { CreateNewRoomStepsEnum } from '../utils';

const AutoRemindersStepModal = () => {
  const { t } = useTranslation();
  const {
    handleExit,
    setCurrentStep,
    setHasToReturnToReview,
    hasToReturnToReview,
    roomForm: {
      watch,
      formState: { errors },
    },
  } = useCreateNewRoomDataContext();

  const remindersWatch = watch('reminders');

  const handleBack = () => setCurrentStep(CreateNewRoomStepsEnum.INVITE_PARTICIPANTS);
  const handleNext = () => {
    setHasToReturnToReview(false);
    setCurrentStep(CreateNewRoomStepsEnum.REVIEW_ROOM);
  };

  const modalTitle = `${t('set_auto_reminders')} (${t('optional').toLowerCase()})`;
  const hasActiveReminder = remindersWatch.some(({ enabled }) => enabled);
  const hasErrorInActiveReminder = remindersWatch.some(({ enabled }, i) => enabled && errors.reminders?.[i]);
  const nextOrSkipText = hasActiveReminder ? t('next') : t('skip');
  const primaryButtonText = hasToReturnToReview ? t('save') : nextOrSkipText;

  return (
    <Popup isVisible>
      <Popup.FullScreenContainer className="md:w-[512px]">
        <Popup.Header className="!justify-between !text-size-md !mx-0 p-4">
          {modalTitle}
          <Popup.CloseIcon closePopup={handleExit} className="!static" />
        </Popup.Header>
        <div className="flex grow overflow-y-auto gap-5 p-4" data-testid={testingConstants.autoRemindersModal}>
          <Notification className="stroke-gray-60 h-6 w-6 shrink-0 stroke-1.5" />
          <div className="flex flex-col w-full gap-4">
            <span className="text-size-sm text-black">{t('remind_participants_about_the_meeting')}</span>
            <RemindersList />
          </div>
        </div>
        <ModalFooter
          onCloseClick={handleBack}
          onSubmit={handleNext}
          successButtonText={primaryButtonText}
          cancelText={t('back')}
          successDisabled={hasErrorInActiveReminder}
          isCancelButtonHidden={hasToReturnToReview}
        />
      </Popup.FullScreenContainer>
    </Popup>
  );
};

export default AutoRemindersStepModal;
